import axios from 'axios'

const axiosInstance = axios.create();
let counter = 0
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { response, config } = error;

    // якщо немає response — це не HTTP-помилка
    if (!response) {
      return Promise.reject(error);
    }

    if (
      response.status === 403 &&
      config?.url?.includes('/api/auth/authorise')
    ) {
      return Promise.resolve({
        data: null,
        status: 200,
        statusText: 'OK',
        headers: response.headers,
        config,
      });
    }

    // щоб не зациклитись
    if (response.status === 409 && !config.__retry && counter <= 3) {
      config.__retry = true;
      counter++;

      // легонький дебонс 5s
      await new Promise((resolve) => setTimeout(resolve, 5000));

      // повторити ТОЙ САМИЙ запит
      return axiosInstance(config);
    } else if (response.status === 409 && !config.__retry && counter > 3) {
      // якщо після 3 спроб все ще 409, то скидаємо лічильник і віддаємо помилку
      counter = 0;
    }

    console.error(response);
    return Promise.reject(error);
  }
);

export default axiosInstance;
